import '../../../FE/src/assets/javascripts/libs/slick.js';

/**
 * Testimonials Slider - Slick Implementation
 * Syncs 2 sliders: background images and testimonials track
 * Each slider instance has unique arrows
 * Pattern updates per slide change
 * No autoplay, loop enabled
 */
export default class TestimonialsSlider {
  constructor(el) {
    this.$this = $(el);
    this.$wrapper = this.$this.find('.testimonials-slider__wrapper');
    this.$trackSlider = this.$this.find('.testimonials-slider__track');
    this.$pattern = this.$this.find('[data-slider-pattern]');
    this.animationBg = 0;
    // Track last action: 'next' or 'prev'
    this.lastAction = null;
    this.clsSlide = 'testimonials-slider__slide';

    if (this.$trackSlider.length > 0) {
      this.init();
    }
  }

  init() {
    this.initSliders();
    this.bindEvents();
    this.updatePatternColor(0);
  }

  initSliders() {
    const totalSlides = this.$trackSlider.find(
      `.${this.clsSlide}`,
    ).length;

    if (totalSlides === 0) {
      return;
    }

    // Initialize Testimonials Track Slider
    this.$trackSlider.slick({
      rows: 0,
      slide: `.${this.clsSlide}`,
      slidesToShow: 1,
      slidesToScroll: 1,
      // Loop enabled
      infinite: true,
      // No autoplay
      autoplay: false,
      arrows: false,
      dots: false,
      fade: true,
      speed: 0,
      swipe: true,
      draggable: true,
      accessibility: true,
      focusOnSelect: false,
    });
  }

  bindEvents() {
    // Detect swipe direction
    this.$trackSlider.on('swipe', (_event, _slick, direction) => {
      if (direction === 'left') {
        this.lastAction = 'next';
        this.animationBg -= 150;
      } else if (direction === 'right') {
        this.lastAction = 'prev';
        this.animationBg += 150;
      } else {
        // no changes
      }
    });
    this.$this.on('click', '.gg-slick-arrow', (e) => {
      const $btn = $(e.currentTarget);
      if ($btn.hasClass('slick-prev')) {
        this.lastAction = 'prev';
        this.$trackSlider.slick('slickPrev');
        this.animationBg += 150;
      } else {
        this.lastAction = 'next';
        this.$trackSlider.slick('slickNext');
        this.animationBg -= 150;
      }
    });
    // Add hover effects for navigation arrows
    // Sync sliders when track slider changes
    this.$trackSlider.on('afterChange', (_event, _slick, currentSlide) => {
      // Update pattern color
      this.updatePatternColor(currentSlide);
    });

  }

  updatePatternColor(slideIndex) {
    if (!this.$pattern.length) {
      return;
    }

    const $currentSlide = this.$trackSlider
      .find(`.${this.clsSlide}`)
      .eq(slideIndex);
    const showPattern =
      $currentSlide.data('show-pattern') === true ||
      $currentSlide.data('show-pattern') === 'true';
    const patternColorClass = $currentSlide.data('pattern-color') || 'bg-secondary-stone';

    // Remove all possible background color classes
    this.$pattern.removeClass('bg-secondary-stone bg-secondary-700 bg-secondary-mist bg-secondary-300 bg-secondary-600 bg-secondary-800 bg-secondary-900 bg-secondary-950');

    if (showPattern) {
      this.$pattern.addClass(patternColorClass).removeClass('opacity-0');
    } else {
      this.$pattern.addClass('opacity-0');
    }
    this.$pattern.find('.testimonials-slider__pattern--inner').css('opacity', '0');
    this.$pattern.find('.testimonials-slider__pattern--inner').eq(slideIndex).css('opacity', '1');
    this.$this.css('--animation-bg', `${this.animationBg}px`);
  }

  destroy() {
    if (this.$trackSlider.hasClass('slick-initialized')) {
      this.$trackSlider.slick('unslick');
    }
  }
}

// Initialize all testimonials sliders on the page
function initTestimonialsSliders() {
  const $sliders = $('.testimonials-slider');

  if ($sliders.length === 0) {
    return;
  }

  $sliders.each(function () {
    const instance = new TestimonialsSlider(this);
    $(this).data('testimonials-slider-instance', instance);
  });
}

initTestimonialsSliders();
